import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { PERMISSIONS } from "app/utils/permissions";

const CustomerTypeList = Loadable(lazy(() => import("./CustomerTypeList")));
const CustomerTypeForm = Loadable(lazy(() => import("./CustomerTypeForm")));

const customerTypeRoutes = [
  {
    path: "/CustomerType/CustomerTypeList",
    element: <CustomerTypeList />,
    permission: PERMISSIONS.CustomerTypes.Menu,
  },
  {
    path: "/CustomerType/CustomerTypeForm",
    element: <CustomerTypeForm />,
  },
  {
    path: "/CustomerType/CustomerTypeForm/:customerTypeId",
    element: <CustomerTypeForm />,
  },
];

export default customerTypeRoutes;
